/// <reference path="../../../../../typings/index.d.ts" />
module Meevo.Plugins.Discounts {
    'use strict';

    import DiscountEntityTypeEnum = Meevo.Model.DiscountEntityTypeEnum;

    enum ToggleEnum {
        selected,
        deselected
    }

    interface ICategory {
        displayName: string;
        id: number
    }

    interface IItem {
        displayName: string,
        id: number,
        selected?: boolean
    }

    interface IDiscountsMoverToolController {
        title?: string;
        buyGetTitle?: string
        discountEntityType?: DiscountEntityTypeEnum;
        manufacturerId?: Guid;
        isReadonly?: boolean;
        isBuyGet?: boolean;
        categoriesApiUrl?: string,
        itemsApiUrl?: string,
        ngModel: angular.INgModelController;
        fetching: boolean;

        itemsSelection: Array<IItem>;
        selectedItemsSelection: Array<IItem>;

        selectedCategoryId: Guid | string;
        categories: Array<ICategory>;
        items: Array<IItem>;
        isItemsChangedManually: boolean;
        init(): void;
        select(): void;
        deselect(): void;
        toggleAll(toggle: ToggleEnum): void;
        checkItems(toggle: ToggleEnum): boolean;
        getSelectedItems(): Array<IItem>;
        prePopulate(): void;
        setModelValue(): void;
        categoryChanged(): void;
        getCategories(): ng.IPromise<any>;
        getItemsByCategory(): ng.IPromise<any>;
        changed?: Function;
    }

    export class DiscountsMoverToolController implements IDiscountsMoverToolController {
        discountEntityType: DiscountEntityTypeEnum;
        manufacturerId: Guid;
        isReadonly: boolean;
        isBuyGet: boolean;

        categoriesApiUrl: string = '';
        itemsApiUrl: string = '';

        ngModel: angular.INgModelController;
        fetching: boolean = true;

        itemsSelection: Array<IItem> = [];
        selectedItemsSelection: Array<IItem> = [];

        selectedCategoryId: Guid | string = "";
        categories: Array<ICategory> = [];
        items: Array<IItem> = [];
        isItemsChangedManually: boolean = false;

        changed:Function;

        static $inject = [
            '$scope',
            '$q',
            '$timeout',
            '$translate',
            'meevo.components.common.DataService',
            'meevo.components.busy.BusyService'
        ];

        constructor(
            protected $scope: angular.IScope,
            protected $q: ng.IQService,
            protected $timeout: ng.ITimeoutService,
            protected $translate: angular.translate.ITranslateService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService
        ) {}

        /**
         * Function to be called when directive is initialized
         */
        init(): void {
            this.$timeout(() => {
                if (!angular.isArray(this.ngModel.$viewValue)) {
                    this.ngModel.$setViewValue([]);
                }
            });

            switch (this.discountEntityType) {
                case DiscountEntityTypeEnum.RebookedAppointments:
                case DiscountEntityTypeEnum.Service:
                    this.categoriesApiUrl = 'ServiceCategory';
                    this.itemsApiUrl = 'Service';
                    break;
                case DiscountEntityTypeEnum.Product:
                    this.categoriesApiUrl = 'ProductSubCategory';
                    this.itemsApiUrl = 'ProductVariant';
                    break;
                case DiscountEntityTypeEnum.Package:
                    this.itemsApiUrl = 'PackageType';
                    break;
                case DiscountEntityTypeEnum.Membership:
                    this.itemsApiUrl = 'Membership';
                    break;
                case DiscountEntityTypeEnum.GiftCard:
                    this.itemsApiUrl = 'GiftCardType';
                    break;
            }

            this.$scope.$watch(() => this.manufacturerId, (newValue: Guid, oldValue: Guid) => {
                if (newValue === oldValue) {
                    return;
                }

                this.busyService.start();
                this.getItemsByCategory()
                    .finally(() => {
                        this.busyService.stop();
                    });
            }); 

            this.$scope.$watch(() => this.ngModel.$viewValue, (newValue, oldValue) => {
                if (angular.isDefined(newValue) && !angular.equals(newValue, oldValue) && !this.isItemsChangedManually) {
                    this.prePopulate();
                }

                this.isItemsChangedManually = false;
            }, true);

            this.busyService.start();
            this.$q.all([
                this.getCategories(),
                this.getItemsByCategory()
            ])
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Select item
         */
        select(): void {
            this.itemsSelection.forEach((item: IItem) => {item.selected = true;});
            this.setModelValue();
        }

        /**
         * Deselect item
         */
        deselect(): void {
            this.selectedItemsSelection.forEach((item: IItem) => {item.selected = false;});
            this.setModelValue();
        }

        /**
         * Select or deselect all items in one time
         * @param {ToggleEnum} toggle
         */
        toggleAll(toggle: ToggleEnum): void {
            let selected = toggle === ToggleEnum.selected;

            this.items.forEach((item: IItem) => {item.selected = selected;});

            this.setModelValue();
        }

        /**
         * Check if all items are selected
         * @param {ToggleEnum} toggle
         * @returns {boolean}
         */
        checkItems(toggle: ToggleEnum): boolean {
            let selected = toggle === ToggleEnum.selected;

            return this.items.every((item: IItem) => item.selected === selected);
        }

        /**
         * Get selected items
         * @returns {Array} IItem
         */
        getSelectedItems(): Array<IItem> {
            return this.items.filter((item: IItem) => item.selected);
        }

        /**
         * Pre populate selected items based on ngModel value
         */
        prePopulate(): void {
            this.items.forEach((item: IItem) => {
                item.selected = false;
            });

            this.ngModel.$viewValue.forEach((selectedItem: IItem) => {
                selectedItem.selected = true;

                for (var i = 0; i < this.items.length; i++) {
                    let item: IItem = this.items[i];

                    if (selectedItem.id === item.id) {
                        let index = this.items.indexOf(item);

                        this.items.splice(index, 1);
                        break;
                    }
                }

                this.items.push(selectedItem);
            });
        }

        /**
         * Set model value
         */
        setModelValue(): void {
            this.isItemsChangedManually = true;
            this.ngModel.$setViewValue(this.getSelectedItems());

            if(this.changed){
                this.changed();
            }
        }

        /**
         * User selects another category through select box
         */
        categoryChanged(): void {
            this.busyService.start();
            this.getItemsByCategory()
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Get categories
         * @returns {ng.IPromise<any>} promise
         */
        getCategories(): ng.IPromise<any> {
            let deferred = this.$q.defer();
            let data: Object = {
                criteria: {},
                itemsPerPage: 10000
            };

            if (this.categoriesApiUrl) {
                this.dataService.getListPaged(this.categoriesApiUrl, data)
                    .then((categories: Array<ICategory> | any) => {
                        this.categories = categories;
                        deferred.resolve();
                    })
                    .catch(() => {
                        deferred.reject();
                    });
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        /**
         * Get items (services, products, packages)
         * @returns {ng.IPromise<any>} promise
         */
        getItemsByCategory(): ng.IPromise<any> {
            let data: Object = {
                criteria: {},
                itemsPerPage: 10000
            };

            switch (this.discountEntityType) {
                case DiscountEntityTypeEnum.GiftCard:
                    data['criteria']['isPromo'] = false;
                    break;
                    
                case DiscountEntityTypeEnum.Service:
                    if (this.selectedCategoryId) {
                        data['criteria']['serviceCategoryId'] = this.selectedCategoryId;
                    }
                    break;

                case DiscountEntityTypeEnum.Product:
                    if (this.selectedCategoryId) {
                        data['criteria']['productSubCategoryId'] = this.selectedCategoryId;
                    }
                    if (this.manufacturerId) {
                        data['criteria']['manufacturerId'] = this.manufacturerId;
                    }
                    data['criteria']['includeBundles'] = true;
                    data['criteria']['includeProducts'] = true;
                    data['criteria']['variantObjectState'] = [ Model.ObjectStateEnum.Active, Model.ObjectStateEnum.Inactive ];
                    break;
            }            

            return this.dataService.getListPaged(this.itemsApiUrl, data)
                .then((items: Array<IItem> | any) => {
                    this.items = items;
                    this.prePopulate();
                });
        }

        get toggleEnum(): any {
            return ToggleEnum;
        }

        getDisplayName(item): string {
            const isDiscontinued = item.objectState === Model.ObjectStateEnum.Inactive || item.varObjectState === Model.ObjectStateEnum.Inactive;
            const discontinued = isDiscontinued ? '*' + this.$translate.instant("LABEL_DISCONTINUED") + ' ' : '';
            const shortcut = item.shortcut ? `${item.shortcut}: ` : '';
            const sku = item.sku ? `${item.sku}: ` : '';

            return discontinued 
                + shortcut
                + sku
                + item.displayName 
                + this.getVariantName(item);
        }

        getVariantName(item): string {
            if (item.variantAttributes && item.variantAttributes.length > 0) {
                return ': ' + _.chain(item.variantAttributes).pluck('displayName').flatten().join("|").value();
            }
            return "";
        }
    }
}